import { render, staticRenderFns } from "./new.school.page.vue?vue&type=template&id=fba01372&"
import script from "./new.school.page.vue?vue&type=script&lang=js&"
export * from "./new.school.page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports